const GAMEBENDER_HOOK_LISTS = [
  'SpriteList',
  '$gamebender_messages',
  '$applied_glitches'
]

function generateSaveData (state) {
  const saveData = state.sceneMetadata
  saveData.projectId = state.projectId
  saveData.sceneId = state.sceneId
  saveData.exposedVariables = state.sceneMetadata.exposedVariables
  saveData.startingParts = state.addedParts
  saveData.startingGlitches =
    state.glitchApplications.map(glitchApplication => {
      const target = state.vm.runtime.targets.find(
        t => t.id === glitchApplication.targetId
      )
      return {
        glitchId: glitchApplication.glitchId,
        spriteName: target.sprite.name
      }
    })

  const originals = state.vm.runtime.targets.filter(t => t.isOriginal)
  saveData.spriteProperties = originals.map(original => {
    const variables = Object.values(original.variables)
      .filter(v => v.type === '')
      .map(v => ({
        name: v.name,
        value: v.value
      }))
    const lists = Object.values(original.variables)
      .filter(v => v.type === 'list'
      && !GAMEBENDER_HOOK_LISTS.includes(v.name))
      .map(v => ({
        name: v.name,
        value: v.value
      }))
    const data = {
      name: original.sprite.name,
      x: Number(original.x.toFixed(2)),
      y: Number(original.y.toFixed(2)),
      size: Number(original.size.toFixed(2)),
      direction: Number(original.direction.toFixed(2)),
      variables,
      currentCostume: original.currentCostume,
      lists
    }
    return data
  })
  return saveData
}

module.exports = {generateSaveData}
